import type { AnyProfile, ValidationResult, Profile } from '@/types'
import { credentialsManager } from './credentials-manager'

/**
 * Validates that required API keys are present for the selected profiles.
 * Returns { valid: true } if all keys are present, or { valid: false, errors: [...] } with descriptive messages.
 */
export async function validateApiKeysForProfiles(profiles: AnyProfile[]): Promise<ValidationResult> {
  const missing: string[] = []

  for (const profile of profiles) {
    if (!profile.enabled) continue

    // Preset profiles are always type 'bedrock' - no API key needed
    if ('isPreset' in profile && profile.isPreset) continue

    const p = profile as Profile
    if (p.type === 'anthropic-direct' && !(await credentialsManager.getAnthropicApiKey())) {
      missing.push('Anthropic API key required for anthropic-direct profiles')
    }
    if (p.type === 'grok' && !(await credentialsManager.getXaiApiKey())) {
      missing.push('xAI API key required for grok profiles')
    }
  }

  // Deduplicate
  const unique = [...new Set(missing)]
  return { valid: unique.length === 0, errors: unique }
}
